/* eslint-disable import/prefer-default-export */

export const recipientFields = (
  partnerUser,
  shipped,
  zipCodeSettings = null,
  isInvalidZipCode = null,
  prizeId = null
) => [
  {
    label: 'Recipient Info',
    recipientData: [
      {
        label: 'First Name',
        val: '',
        name: 'first_name',
        type: 'input',
        rule: [value => (value && value.length >= 1) || 'Required']
      },
      {
        label: 'Last name',
        val: '',
        name: 'last_name',
        type: 'input',
        rule: [value => (value && value.length >= 1) || 'Required']
      },
      {
        label: 'Email',
        val: '',
        name: 'email',
        type: 'input',
        rule: [
          value => {
            if (value && !/(.+)@(.+)\.(.+){2,}/.test(value))
              return 'Enter a Valid Email';
            if (value && value === partnerUser.email && shipped)
              return 'You cannot ship this to yourself';
            return true;
          }
        ]
      },
      {
        label: 'Mobile Phone (optional)',
        val: '',
        name: 'phone'
        // rule: [
        //   value =>
        //     (value &&
        //       // eslint-disable-next-line max-len
        //       /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(
        //         value
        //       )) ||
        //     'Enter a Valid Number'
        // ]
      }
    ]
  },
  {
    label: 'Shipping Info',
    shippingData: [
      {
        label: 'Street Address',
        val: '',
        name: 'address',
        type: 'input',
        rule: [value => (value && value.length >= 1) || 'Required']
      },
      {
        label: 'Suite/Apt #',
        val: '',
        name: 'address_2',
        type: 'input'
      },
      {
        label: 'Country',
        val: '',
        name: 'country',
        type: 'select',
        rule: [value => (value && value.length >= 1) || 'Required'],
        triggerUpdate: 'state',
        items: [
          { value: 'US', text: 'United States' },
          { value: 'CA', text: 'Canada' }
        ]
      },
      {
        label: 'State',
        val: undefined,
        name: 'state',
        type: 'select',

        rule: [value => (value && !!value) || 'Required']
      },
      {
        label: 'City',
        val: '',
        name: 'city',
        type: 'input',
        rule: [value => (value && value.length >= 1) || 'Required']
      },
      {
        label: 'Zip, Postal Code',
        val: '',
        name: 'zip_code',
        type: 'input',
        rule: [
          value => (value && value.length >= 1) || 'Required',
          value => {
            if (value && value.length < 3) return 'Enter a Valid Zip Code';
            return true;
          },
          value => {
            if (
              zipCodeSettings &&
              isInvalidZipCode(value, prizeId, zipCodeSettings)
            )
              return 'Zip code not eligible for this reward.';
          }
        ]
      }
    ]
  }
];

export const isInvalidZipCode = (value, prizeId, zipCodeSettings = {}) => {
  if (!zipCodeSettings || Object.keys(zipCodeSettings).length === 0)
    return false;
  if (
    zipCodeSettings.package_ids?.length > 0 ||
    zipCodeSettings.deal_ids?.length > 0 ||
    zipCodeSettings.product_ids?.length > 0
  )
    if (prizeId && !zipCodeSettings.product_ids.includes(prizeId)) return false;
  const trimmedValue = value.trim();
  if (
    zipCodeSettings.excluded_zip_codes &&
    zipCodeSettings.excluded_zip_codes.includes(trimmedValue)
  ) {
    return (
      zipCodeSettings.message ||
      'The zip code you entered is not eligible for this experience.'
    );
  }

  if (
    zipCodeSettings.included_zip_codes &&
    !zipCodeSettings.included_zip_codes.includes(trimmedValue)
  ) {
    return (
      zipCodeSettings.message ||
      'The zip code you entered is not eligible for this experience.'
    );
  }

  return false;
};

const toOption = item => ({ value: item, text: item });

export const statesByCountry = country => {
  const states = {
    US: [
      'Alabama',
      'Alaska',
      'American Samoa',
      'Arizona',
      'Arkansas',
      'California',
      'Colorado',
      'Connecticut',
      'Delaware',
      'District of Columbia',
      'Federated States of Micronesia',
      'Florida',
      'Georgia',
      'Guam',
      'Hawaii',
      'Idaho',
      'Illinois',
      'Indiana',
      'Iowa',
      'Kansas',
      'Kentucky',
      'Louisiana',
      'Maine',
      'Marshall Islands',
      'Maryland',
      'Massachusetts',
      'Michigan',
      'Minnesota',
      'Mississippi',
      'Missouri',
      'Montana',
      'Nebraska',
      'Nevada',
      'New Hampshire',
      'New Jersey',
      'New Mexico',
      'New York',
      'North Carolina',
      'North Dakota',
      'Northern Mariana Islands',
      'Ohio',
      'Oklahoma',
      'Oregon',
      'Palau',
      'Pennsylvania',
      'Puerto Rico',
      'Rhode Island',
      'South Carolina',
      'South Dakota',
      'Tennessee',
      'Texas',
      'Utah',
      'Vermont',
      'Virgin Island',
      'Virginia',
      'Washington',
      'West Virginia',
      'Wisconsin',
      'Wyoming'
    ].map(toOption),
    CA: [
      'Alberta',
      'British Columbia',
      'Manitoba',
      'New Brunswick',
      'Newfoundland and Labrador',
      'Northwest Territories',
      'Nova Scotia',
      'Nunavut',
      'Ontario',
      'Prince Edward Island',
      'Quebec',
      'Saskatchewan',
      'Yukon Territory'
    ].map(toOption)
  };

  return states[country] || [];
};
